import { TDescendant, TElement } from "@udecode/plate-common";
import { PluginConfig } from "@udecode/plate-core";
import { PlateEditor, createTPlatePlugin } from "@udecode/plate/react";

type ReplacementConfig = PluginConfig<"replacement", { replacements: Record<string, string> }>;

const ReplacementPlugin = createTPlatePlugin<ReplacementConfig>({
    key: "replacement",
    options: {
        replacements: {},
    },
    handlers: {
        onChange: ({ editor, getOption }) => {
            const replacements = getOption("replacements");

            for (const [key, value] of Object.entries(replacements)) {
                replaceTriggerWord(editor, key, value);
            }
        },
    },
});
export default ReplacementPlugin;

const replaceTriggerWord = (
    editor: PlateEditor,
    triggerWord: string,
    replacementString: string
) => {
    const triggerString = triggerWord + " ";

    const triggerPoint = findTriggerWordAtCursor(editor, triggerString);
    if (!triggerPoint) {
        return;
    }

    const { path, offset } = triggerPoint;

    editor.delete({
        at: {
            anchor: {
                path,
                offset: offset - triggerString.length,
            },
            focus: triggerPoint,
        },
    });
    editor.insertText(replacementString + " ");
};

type TNode = PlateEditor | TElement | TDescendant[] | TDescendant;

function findTriggerWordAtCursor(editor: PlateEditor, triggerString: string) {
    const focus = editor.selection?.focus;
    if (!focus) {
        return null;
    }

    const { path, offset } = focus;

    let node: TNode = editor;
    for (const index of path) {
        node = node.children[index];
    }

    if (typeof node.text !== "string") {
        return null;
    }

    const nodeTillCursor = node.text.slice(0, offset);

    const triggered =
        nodeTillCursor.endsWith(" " + triggerString) || nodeTillCursor === triggerString;

    if (!triggered) {
        return null;
    }

    return focus;
}
